// utils/TokenService.js
// Phase 1: Token service with backward compatibility for localStorage

let memoryAccessToken = null;
const USE_LEGACY_STORAGE = process.env.REACT_APP_AUTH_PERSIST_LOCALSTORAGE !== 'false';

/**
 * TokenService - Manages access token storage with backward compatibility
 * Phase 1: Supports both memory and localStorage (legacy)
 * Future phases will remove localStorage dependency
 */
export const TokenService = {
  /**
   * Set access token in memory and optionally localStorage (for backward compatibility)
   * @param {string|null} token - The access token to store
   */
  setAccessToken(token) {
    memoryAccessToken = token || null;

    if (USE_LEGACY_STORAGE) {
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    }
  },

  /**
   * Get access token from memory (preferred) or localStorage (legacy fallback)
   * @returns {string|null} The access token or null
   */
  getAccessToken() {
    return memoryAccessToken || (USE_LEGACY_STORAGE && localStorage.getItem('token')) || null;
  },

  /**
   * Clear access token from both memory and localStorage
   */
  clearAccessToken() {
    memoryAccessToken = null;

    if (USE_LEGACY_STORAGE) {
      localStorage.removeItem('token');
    }
  },
};

export default TokenService;
